// Canonical list of HTTP header names that carry auth tokens.
// Used by ApiClient (to redact from error payloads) and sanitizeGroundcoverEvent
// (to scrub from RUM telemetry — both network headers and exception messages).  (PCD-9824)
export const SENSITIVE_AUTH_HEADER_NAMES = [
  'x-auth-token',
  'x-subject-token',
  'authorization',
  'unscopedtoken',
] as const

export type SensitiveAuthHeaderName = (typeof SENSITIVE_AUTH_HEADER_NAMES)[number]
